/**
 * @generated SignedSource<<6483d8798b59a9e59ec84d3fdc5d4186>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespIconBubbleShare_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedIconBubbleEmail_viewer">;
  readonly " $fragmentType": "PdpRespIconBubbleShare_viewer";
};
export type PdpRespIconBubbleShare_viewer$key = {
  readonly " $data"?: PdpRespIconBubbleShare_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespIconBubbleShare_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespIconBubbleShare_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedIconBubbleEmail_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "76095f9fe3ef9b6d3094a7154dc13186";

export default node;
